
  import { defineComponent, PropType } from 'vue';

  import { TDashboardRegionFilter } from '@/modules/ves/types/regionDashboards';

  import { DASHBOARDS_VES_ACTIONS_NAME, DASHBOARDS_VES_GETTERS_NAME } from '../../store/dashboards/name';
  import { TDashboardsIndicatorCardsConfig } from './dashboards-indicator-cards/types';
  import DashboardsIndicatorCardsWithModals from './dashboards-indicator-cards-with-modals/DashboardsIndicatorCardsWithModals.vue';
  import { TModalsConfig } from './dashboards-indicator-cards-with-modals/types';

  export default defineComponent({
    name: 'DashboardsCards',
    components: {
      DashboardsIndicatorCardsWithModals,
    },
    props: {
      filter: {
        type: Object as PropType<Partial<TDashboardRegionFilter>>,
        required: true,
      },
    },
    data(): {
      cardsConfig: TDashboardsIndicatorCardsConfig;
      modalsConfig: TModalsConfig;
    } {
      return {
        cardsConfig: {
          action: DASHBOARDS_VES_ACTIONS_NAME.getRegionStatistic,
          getter: DASHBOARDS_VES_GETTERS_NAME.getRegionStatistic,
        },
        modalsConfig: {
          eventsCountByTypes: {
            action: DASHBOARDS_VES_ACTIONS_NAME.getEventsCountByTypes,
            getter: DASHBOARDS_VES_GETTERS_NAME.getEventsCountByTypes,
          },
          agreementsCountByTypes: {
            action: DASHBOARDS_VES_ACTIONS_NAME.getAgreementsCountByTypes,
            getter: DASHBOARDS_VES_GETTERS_NAME.getAgreementsCountByTypes,
          },
        },
      };
    },
    watch: {
      filter: {
        handler(newVal) {
          if (newVal.year && newVal.countryId) {
            this.$nextTick(() => {
              this.$forceUpdate();
            });
          }
        },
        deep: true,
        immediate: true,
      },
    },
  });
